import { createTheme, PaletteColorOptions } from "@mui/material";
import { esES } from '@mui/material/locale';

// import { red } from "@mui/material/colors";

declare module '@mui/material/styles' {
    interface Palette {
        fondo?: Palette['primary'];
    }
    interface PaletteOptions {
        fondo?: PaletteOptions['primary'];
    }
}

export const ThemeDetails = createTheme(
    esES, {
    /* COLORES PRINCIPALES */

    palette: {

        primary: {
            main: "#233367",
            light: "#53597E",
            dark: "#1B1D4C",
            contrastText: "#ffffff",
        },
        secondary: {
            main: "#75b0f5",
            light: "#a6c8fa", // Un tono más claro del color secundario
            dark: "#4277c2", // Un tono más oscuro del color secundario
            contrastText: "#ffffff",
        },
        fondo: {
            main: "#F9FBFD",
        },
    },

    /* TIPOS DE LETRAS PARA LAS VARIANTES DE MATERIAL */
    typography: {
        h1: {
            fontFamily: 'Montserrat',
        },
        h2: {
            fontFamily: 'Montserrat',
        },
        h3: {
            fontFamily: 'Montserrat',
        },
        h4: {
            fontFamily: 'Montserrat',
        },
        h5: {
            fontFamily: 'Montserrat',
        },
        h6: {
            fontFamily: 'Montserrat',
        },
    },
    components: {
        MuiContainer: {
            defaultProps: {
                maxWidth: 'xl', // Establece el ancho máximo predeterminado para Container
            },
        },
    },

});